/* SHADOW v6 — kurv-skuffe (AJAX + Section Rendering API), læg i kurv, varianter, galleri, zoom, sticky køb.
   Alle priser og kurvlinjer renderes af Liquid i sections/sh6-cart.liquid — intet er hardcodet her. */
(function () {
  'use strict';
  var SECTION = 'sh6-cart';
  var body = document.body;
  var drawer = document.getElementById('sh6-drawer');
  var lastFocus = null;

  function setInert(on) {
    ['main', '.nav', '.footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }
    });
  }
  function openDrawer() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    body.classList.add('sh6-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    setInert(true);
    var c = drawer.querySelector('[data-sh6-close]');
    if (c) setTimeout(function () { c.focus(); }, 60);
    return true;
  }
  function closeDrawer() {
    if (!drawer) return;
    body.classList.remove('sh6-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    setInert(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderCart(html) {
    if (!html || !drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.sh6-drawer__content');
    var cur = drawer.querySelector('.sh6-drawer__content');
    if (fresh && cur) cur.replaceWith(fresh);
    var count = fresh ? fresh.getAttribute('data-count') : null;
    if (count !== null) {
      document.querySelectorAll('[data-sh6-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
    }
  }
  function sectionsUrl() { return window.location.pathname; }

  async function cartRequest(url, payload) {
    payload.sections = SECTION;
    payload.sections_url = sectionsUrl();
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Noget gik galt. Prøv igen.');
    }
    return data;
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sh6-cart-open]');
    if (openBtn && drawer && !body.classList.contains('tpl-cart')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-sh6-close]') || e.target.closest('[data-sh6-overlay]')) { closeDrawer(); return; }
    var line = e.target.closest('.sh6-line');
    if (!line) return;
    var step = e.target.closest('[data-sh6-step]');
    var remove = e.target.closest('[data-sh6-remove]');
    if (!step && !remove) return;
    var input = line.querySelector('input');
    var qty = remove ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.sh6Step, 10));
    changeLine(line, qty);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.sh6-line input');
    if (!input) return;
    changeLine(input.closest('.sh6-line'), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('sh6-drawer-open')) closeDrawer();
  });

  async function changeLine(line, qty) {
    line.classList.add('is-loading');
    try {
      var data = await cartRequest('/cart/change.js', { line: parseInt(line.dataset.line, 10), quantity: qty });
      renderCart(data.sections && data.sections[SECTION]);
    } catch (ex) {
      try {
        var r = await fetch(sectionsUrl() + '?sections=' + SECTION);
        var j = await r.json();
        renderCart(j[SECTION]);
      } catch (_) { line.classList.remove('is-loading'); }
      var err = drawer.querySelector('[data-sh6-cart-error]');
      if (err) err.textContent = ex.message;
    }
  }

  /* Læg i kurv (produktside og produktkort). "Køb nu" (name=return_to) går direkte til Shopify checkout. */
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('form.sh6-add-form');
    if (!form || !drawer) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'return_to') return;
    e.preventDefault();
    var btn = submitter || form.querySelector('[type="submit"]');
    var err = form.querySelector('.sh6-error');
    if (err) err.textContent = '';
    var id = form.querySelector('[name="id"]').value;
    var qEl = form.querySelector('[name="quantity"]');
    var quantity = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    try {
      var data = await cartRequest('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: quantity }] });
      renderCart(data.sections && data.sections[SECTION]);
      openDrawer();
    } catch (ex) {
      if (err) err.textContent = ex.message;
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }
  });

  document.querySelectorAll('.sh6-qty[data-sh6-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var max = parseInt(input.max || '99', 10);
        input.value = Math.max(1, Math.min(max, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10)));
      });
    });
  });

  /* Produktside: galleri, zoom, varianter, sticky */
  document.querySelectorAll('[data-sh6-pdp]').forEach(function (root) {
    var track = root.querySelector('.sh6-gal__track');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.sh6-gal__thumb'));
    var counter = root.querySelector('[data-sh6-counter]');
    function goTo(i) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function mark(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); mark(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
      }, { passive: true });
    }

    var dialog = root.querySelector('.sh6-zoom');
    if (dialog && dialog.showModal) {
      var zimg = dialog.querySelector('img');
      root.querySelectorAll('[data-sh6-zoom]').forEach(function (b) {
        b.addEventListener('click', function () { zimg.src = b.dataset.sh6Zoom; zimg.alt = b.dataset.alt || ''; dialog.showModal(); });
      });
      dialog.addEventListener('click', function (e) { if (e.target === zimg || e.target === dialog || e.target.closest('.sh6-zoom__close')) dialog.close(); });
    } else {
      root.querySelectorAll('[data-sh6-zoom]').forEach(function (b) { b.hidden = true; });
    }

    var dataEl = root.querySelector('[data-sh6-variants]');
    var form = root.querySelector('form.sh6-add-form');
    if (dataEl && form) {
      var variants = JSON.parse(dataEl.textContent);
      var idInput = form.querySelector('[name="id"]');
      var priceEl = root.querySelector('[data-sh6-price]');
      var compareEl = root.querySelector('[data-sh6-compare]');
      var addBtn = root.querySelector('[data-sh6-addbtn]');
      var nowBtn = root.querySelector('[data-sh6-now]');
      var stickyPrice = document.querySelector('[data-sh6-sticky-price]');
      var stickyBtn = document.querySelector('[data-sh6-sticky-btn]');
      root.querySelectorAll('.sh6-opt input').forEach(function (input) {
        input.addEventListener('change', function () {
          var chosen = Array.prototype.map.call(root.querySelectorAll('.sh6-opt'), function (fs) {
            var c = fs.querySelector('input:checked'); return c ? c.value : null;
          });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
          var ok = !!(v && v.available);
          if (addBtn) { addBtn.disabled = !ok; addBtn.textContent = ok ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout; }
          if (stickyBtn) stickyBtn.disabled = !ok;
          if (nowBtn) nowBtn.hidden = !ok;
          if (!v) return;
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = v.price;
          if (stickyPrice) stickyPrice.textContent = v.price;
          if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
          if (v.media) {
            var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.media); });
            if (idx > -1) { goTo(idx); mark(idx); }
          }
        });
      });
    }

    var sticky = document.querySelector('[data-sh6-sticky]');
    var anchor = root.querySelector('[data-sh6-buyrow]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(anchor);
      var sb = sticky.querySelector('[data-sh6-sticky-btn]');
      if (sb && form) sb.addEventListener('click', function () {
        var main = root.querySelector('[data-sh6-addbtn]');
        if (form.requestSubmit && main && !main.disabled) form.requestSubmit(main);
        else if (main) main.click();
      });
    }
  });
})();